import { render, staticRenderFns } from "./BreakTheWall.vue?vue&type=template&id=c2c0954c&scoped=true"
import script from "./BreakTheWall.vue?vue&type=script&lang=js"
export * from "./BreakTheWall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0954c",
  null
  
)

export default component.exports